module.exports = __webpack_public_path__ + "img/CSD.bdf9638d.svg";